export default __webpack_public_path__ + "static/media/pokemart.3b04548e.png";